import { render, staticRenderFns } from "./OrderRatingWidget.vue?vue&type=template&id=3765f594&scoped=true&"
import script from "./OrderRatingWidget.vue?vue&type=script&lang=ts&"
export * from "./OrderRatingWidget.vue?vue&type=script&lang=ts&"
import style0 from "./OrderRatingWidget.vue?vue&type=style&index=0&id=3765f594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3765f594",
  null
  
)

export default component.exports